import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../../state-manager/state-model';
import { eventBus } from '../../state-manager/event-bus';
import { domainReplacer } from '../../utils/domain-replacer';
import tpl from './secure-sms-template.hbs';
import { ERRORS } from '../../utils/handle-error';
import { LINKS } from '../../config';

export var SecureSMSView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  events: {
    'click [data-sms-click=confirm]': 'confirm',
    'click [data-sms-click=resend]': 'resend',
    'click [data-sms-click=cancel]': 'cancel',
    'keydown [data-sms-input]': 'onInput',
    'keyup [data-sms-input]': 'onInput'
  },

  initialize: function () {
    var replaceURL = domainReplacer.create();

    this.imagePath = state.get('imagePath');
    this.helpLink = replaceURL(LINKS.oneToOneInquiry);
    this.unregisterLink = replaceURL(LINKS.unregisterSecureSms);

    this.eventBus = eventBus;

    this.listenTo(this.model, 'change:isSent', this.render);
    this.listenTo(this.model, 'sync:auth', this.checkAuthorized);

    this.model.sendSMS();
  },

  render: function () {
    var rendered = this.template(
      _.extend(this.model.toJSON(), {
        imagePath: this.imagePath,
        helpLink: this.helpLink,
        unregisterLink: this.unregisterLink
      })
    );
    this.$el.html(rendered);
    return this;
  },

  cancel: function (e) {
    e.preventDefault();
    this.trigger('fail', {
      resultCode: ERRORS.Silent
    });
    this.remove();
  },

  confirm: function (e) {
    e.preventDefault();
    if (this.model.get('isReady')) {
      this.model.authenticate(this.$('[data-sms-input]').val());
    } else {
      this.eventBus.trigger('show:message', {
        title: '보안 SMS',
        message: '인증번호를 다시 확인해 주세요.'
      });
    }
  },

  resend: function (e) {
    e.preventDefault();
    this.model.sendSMS();
    this.eventBus.trigger('show:message', {
      title: '보안 SMS',
      message: '인증번호를 다시 발송하였습니다.'
    });
  },

  onInput: function (e) {
    var $input = $(e.currentTarget);

    if ($.trim($input.val()).length === 4) {
      this.model.set('isReady', true);
      this.$('.secure-btn__confirm-sms').removeClass('secure-btn--off');
    } else {
      this.model.set('isReady', false);
      this.$('.secure-btn__confirm-sms').addClass('secure-btn--off');
    }
  },

  checkAuthorized: function () {
    var isSuccess = this.model.get('isSuccess');
    var resultCode = this.model.get('resultCode').toString();

    if (isSuccess) {
      state.authenticateMFA(true);
      this.trigger('success');
      this.remove();
    } else if (resultCode === ERRORS.MfaSmsNotMatched) {
      this.eventBus.trigger('show:message', {
        title: '보안 SMS',
        message: '인증번호를 다시 확인해 주세요.'
      });
    } else {
      this.trigger('fail', {
        resultCode: resultCode,
        resultText: this.model.get('resultText')
      });
      this.remove();
    }
  }
});
